// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uibl","label":"styles_label__24KVm"};